import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { RequestListComponent } from './requests-list/request-list.component';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { RequestDetailComponent } from '../../my-requests/request-detail/request-detail.component';
import { ContractModificationDetailComponent } from '../../my-requests/contract-modifications/contract-modification-detail/contract-modification-detail.component';
import { ClientDataRequestDetailsComponent } from '../../my-requests/client-data/client-data-details/client-data-details.component';

export const ADMIN_REQUEST_ROUTES = {
  ASSET_DOCUMENT: 'asset-document',
  CONTRACT_MODIFICATIONS: 'contract-modifications',
  CLIENT_DATA: 'client-data',
};

const routes: Routes = [
  {
    path: 'client-requests',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: RequestListComponent },
      {
        path: 'detail',
        children: [
          { path: `${ADMIN_REQUEST_ROUTES.ASSET_DOCUMENT}/:id`, component: RequestDetailComponent },
          {
            path: `${ADMIN_REQUEST_ROUTES.CONTRACT_MODIFICATIONS}/:id`,
            component: ContractModificationDetailComponent,
          },
          { path: `${ADMIN_REQUEST_ROUTES.CLIENT_DATA}/:id`, component: ClientDataRequestDetailsComponent },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class RequestsRoutingModule {}
